interface StatusMessageProps {
	message?: string | Record<string, string>;
	title?: string | Record<string, string>;
}

export enum DisplayType {
	PurchaseOrders = "PurchaseOrders",
	Transfers = "Transfers",
}

export const RECEIVE_STATUS_DETAILS: Record<string, StatusMessageProps> = {
	Arrived: {
		title: "Arrived",
	},
	PendingReview: {
		message: " pending reviews",
		title: {
			PurchaseOrders: "Manuals Pending Review",
		},
	},
	Reviewing: {
		title: "Manuals In Review",
	},
	InProgress: {
		message: {
			Transfers: "in progress transfer receives waiting to be finalised",
			PurchaseOrders: "in progress receives waiting to be finalised",
		},
		title: "Continue In Progress",
	},
	PendingReceive: {
		message: {
			Transfers: "receives waiting for more stock",
			PurchaseOrders: "receives waiting for more stock or has a credit",
		},
		title: "Pending Receive",
	},
	Incomplete: {
		message: "receives awaiting supplier EDIs",
		title: {
			EDIInvoiceMissing: "Receives Missing EDI",
			Default: "Issues",
		},
	},
	default: {
		message: "receives",
	},
};
